// removed by extract-text-webpack-plugin
module.exports = {"root":"style__root___1bUm2","accept":"style__accept___1TYYq","button":"style__button___Z4_D4","warning":"style__warning___3k0-Y","cancel":"style__cancel___2Crbi","active":"style__active___2ro0I","icon":"style__icon___16pau","label":"style__label___7hZOz"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/snackbar/style.scss
// module id = 505
// module chunks = 0